import { useTranslation } from 'react-i18next';

import { AssistantLikeCardLayout } from './AssistantLikeCardLayout';

export const GeneralTextCard = ({ timestamp, text }: { timestamp: string; text: string }) => {
    return <AssistantLikeCardLayout timestamp={timestamp}>{text}</AssistantLikeCardLayout>;
};

export const FeedbackConfirmedCard = ({ timestamp }: { timestamp: string }) => {
    const { t } = useTranslation('ginger');
    return <GeneralTextCard timestamp={timestamp} text={t('ginger.feedback.confirmed')} />;
};
